import { Dispatch, SetStateAction } from "react";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";

import Column from "components/atoms/Column/Column";
import Audit from "pages/common/ShipmentBilling/components/Audit/Audit";
import Comments from "pages/common/ShipmentBilling/components/Comments/Comments";
import PaymentRouting from "pages/common/ShipmentBilling/components/PaymentRouting/PaymentRouting";
import Files from "pages/common/ShipmentBilling/components/Files/Files";
import Invoice from "pages/common/ShipmentBilling/components/Invoice/Invoice";
import AuditLog from "pages/common/ShipmentBilling/components/AuditLog/AuditLog";
import DebitReference from "pages/common/ShipmentBilling/components/DebitReference/DebitReference";
import CardNew from "components/molecules/Card/CardNew";

interface ShipperShipmentBillingProps {
  isLoading: boolean;
  currentInvoice: any;
  setCurrentInvoice: Dispatch<SetStateAction<any>>;
  totalInvoice: number;
  invoices: any[];
  getAuditLog: () => void;
}

export default function ShipperShipmentBilling({
  isLoading,
  currentInvoice,
  setCurrentInvoice,
  totalInvoice,
  invoices,
  getAuditLog,
}: ShipperShipmentBillingProps) {
  const { id: shipmentId } = useParams();

  return (
    <>
      <Column xs={12} md={8} className="mb-30">
        <CardNew>
          <Invoice isLoading={isLoading} invoice={currentInvoice} totalInvoice={totalInvoice} />
        </CardNew>
        <Row>
          <Col xs={12} md={6} className="mt-15">
            <AuditLog invoiceId={currentInvoice?.invoice_id} />
          </Col>
          <Col xs={12} md={6} className="mt-15 pl-md-0">
            <Comments invoiceId={currentInvoice?.invoice_id} />
          </Col>
        </Row>
      </Column>
      <Column xs={12} md={4}>
        <Audit
          shipmentId={shipmentId!}
          invoices={invoices}
          currentInvoice={currentInvoice}
          setCurrentInvoice={setCurrentInvoice}
          isLoading={isLoading}
          getAuditLog={getAuditLog}
        />
        <PaymentRouting isLoading={isLoading} invoice={currentInvoice} getAuditLog={getAuditLog} />
        <DebitReference isLoading={isLoading} invoice={currentInvoice} />
        <Files
          isLoading={isLoading}
          invoiceId={currentInvoice.invoice_id}
          isInvoiceApproved={currentInvoice.invoice_status === "Approved"}
        />
      </Column>
    </>
  );
}
